/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '../interfaces/Logger';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(Logger);
  private readonly router = inject(Router);

  handleError(error: any): void {
    const enhancedMessage = new Error(`[${this.router?.url}] ${error?.message || 'Unknown error'}`);
    
    this.logger.error(enhancedMessage);
  }
}
